import { Glue42 } from "../../glue";

// provides a unified way to access layouts array
export class LayoutStore {
    private layouts: Glue42.Layouts.Layout[] = [];

    public removeWhere(condition: (l: Glue42.Layouts.Layout) => boolean) {
        this.layouts = this.layouts.filter(condition);
    }

    public removeAll() {
        this.layouts = [];
    }

    public add(item: Glue42.Layouts.Layout) {
        this.layouts.push(item);
    }

    public get all(): Glue42.Layouts.Layout[] {
        return this.layouts;
    }

    public where(condition: (l: Glue42.Layouts.Layout) => boolean): Glue42.Layouts.Layout[] {
        return this.layouts.filter(condition);
    }

    public first(condition: (l: Glue42.Layouts.Layout) => boolean): Glue42.Layouts.Layout {
        return this.where(condition)[0];
    }
}

export default new LayoutStore();
